import { PayloadAction } from "@reduxjs/toolkit";
import { put, call, all } from "redux-saga/effects";

import { IKeyData } from "infrastructure";
import { notification } from "infrastructure/notification";
import { takeLatest } from "infrastructure/store/sagaEffects";
import { securityMessages } from "ui/screens/security/security.localization";
import { filterPickerData } from "ui/screens/security/shared/picker";

import { accountActions } from "./Account.actions";
import { getAccounts, getAccountsToGrantRole } from "./Account.api";
import { IAccountsResponse, IAccountsToGrantRoleResponse } from "./Account.api.types";
import { IAccount, IAccountSearchCriterion } from "./Account.state";

function* loadAccountsExecute({ payload }: PayloadAction<IKeyData<IAccountSearchCriterion>>) {
  try {
    const tenantId = payload.data?.tenantId;
    let accounts: IAccount[] = [];

    if (tenantId) {
      if (payload.data.securityRoleId) {
        const accountsToGrantRoleResponse: IAccountsToGrantRoleResponse[] = yield call(getAccountsToGrantRole, {
          tenantId: tenantId,
          filter: payload.data?.query.query,
          securityRoleId: payload.data.securityRoleId
        });
        accounts = filterPickerData(
          accountsToGrantRoleResponse.map<IAccount>(e => ({ accountName: e.account.name, accountId: e.account.accountId, isPlex: e.isPlexUser })),
          { ...payload.data, defaultValueProvider: e => e.accountName }
        );
      } else {
        const accountsResponse: IAccountsResponse[] = yield call(getAccounts, { tenantId: tenantId, filter: payload.data?.query.query });

        accounts = filterPickerData(
          accountsResponse.map<IAccount>(e => ({ accountName: e.name, accountId: e.accountId })),
          { ...payload.data, defaultValueProvider: e => e.accountName }
        );
      }
    }

    yield put(accountActions.loadAccountsCompleted({ id: payload.id, data: accounts }));
  } catch (e) {
    yield put(accountActions.loadAccountsFailed({ id: payload.id, data: notification.error(e).useMessageId(securityMessages.error("loadAccountsFailed")) }));
  }
}

export function* accountsSaga() {
  yield all([yield takeLatest(accountActions.loadAccounts.toString(), loadAccountsExecute)]);
}
